<template>
  <v-container fluid class="primary h-10">
    <v-row>
      <v-col cols="12" class="text-right">
        <v-tooltip left color="black" v-if="admin">
          <template v-slot:activator="{ on }">
            <v-btn
              :to="{ name: 'admin.users' }"
              class="mr-2"
              v-on="on"
              elevation="0"
              tile
              icon
            >
              <v-icon size="20" color="white">mdi-account-star</v-icon>
            </v-btn>
          </template>
          <span>Admin.</span>
        </v-tooltip>

        <v-tooltip left color="black" v-if="admin">
          <template v-slot:activator="{ on }">
            <v-btn
              :to="{ name: 'groups.create' }"
              class="mr-2"
              v-on="on"
              elevation="0"
              tile
              icon
            >
              <v-icon size="20" color="white">mdi-account-multiple</v-icon>
            </v-btn>
          </template>
          <span>Groups.</span>
        </v-tooltip>

        <v-tooltip left color="black" v-if="admin">
          <template v-slot:activator="{ on }">
            <v-btn
              :to="{ name: 'permissions.create' }"
              class="mr-2"
              v-on="on"
              elevation="0"
              tile
              icon
            >
              <v-icon size="20" color="white">mdi-security</v-icon>
            </v-btn>
          </template>
          <span>Permissions.</span>
        </v-tooltip>

        <v-tooltip left color="black" v-if="admin">
          <template v-slot:activator="{ on }">
            <v-btn
              :to="{ name: 'menu.create' }"
              class="mr-2"
              v-on="on"
              elevation="0"
              tile
              icon
            >
              <v-icon size="20" color="white">mdi-apps</v-icon>
            </v-btn>
          </template>
          <span>Edit menu.</span>
        </v-tooltip>

        <v-tooltip left color="black" v-if="admin">
          <template v-slot:activator="{ on }">
            <v-btn
              class="mr-2"
              :to="{ name: 'setup.create' }"
              v-on="on"
              elevation="0"
              tile
              icon
            >
              <v-icon size="20" color="white">mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create scope.</span>
        </v-tooltip>

        <!-- <v-tooltip left color="black" v-if="admin">
          <template v-slot:activator="{ on }">
            <v-btn
              class="mr-5"
              @click="exit"
              v-on="on"
              elevation="0"
              tile
              icon
            >
              <v-icon size="20" color="white">mdi-logout-variant</v-icon>
            </v-btn>
          </template>
          <span>Sign out.</span>
        </v-tooltip> -->
      </v-col>

      <v-col class="py-10" cols="4" offset="4">
        <v-row :justify="scopes.length < 3 ? 'center' : 'start'">
          <v-col cols="12 text-center" v-if="!scopes.length && !loading">
            <h2 class="title white--text font-weight-light">
              You don't have scopes assigned.
            </h2>
          </v-col>
          <v-col class="py-0 mb-6" cols="4" v-for="s in scopes" :key="s.guid">
            <router-link :to="{ name: 'business-scope.search', params: { scope: s.guid } }">
              <v-avatar tile class="scope scope--overflow" size="100%" color="grey darken-4">
                <span class="scope__text white--text">{{ s.name }}</span>
                <div class="scope__actions" v-if="admin" @click.prevent>
                  <v-btn
                    :to="{ name: 'setup.edit', params: { setup: s.guid } }"
                    color="white"
                    tile
                    icon
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>

                  <app-delete :item="s" @confirm="removeScope(s)">
                    <template v-slot="{ on }">
                      <v-btn
                        color="white"
                        @click.prevent="on.click"
                        tile
                        icon
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                  </app-delete>
                </div>
              </v-avatar>
            </router-link>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';
import { Scope } from '@/api';

export default {
  name: 'app-business-scope',
  data() {
    return {
      scopes: [],
      dialogs: { },
      loading: true,
    };
  },
  computed: {
    ...mapState({
      admin: 'IsAdmin',
    }),
  },
  methods: {
    ...mapMutations({
      logout: 'LOGOUT',
    }),
    async fetchScopes() {
      this.$store.commit('START_LOADING');

      try {
        const { data } = await Scope.fetch();
        this.scopes = data;
      } catch (err) {
        console.debug('ERROR', err);
      }

      this.$store.commit('END_LOADING');
    },
    async removeScope(scope) {
      this.dialogs.delete = false;
      this.$store.commit('START_LOADING');

      try {
        await Scope.delete(scope.guid);
        await this.fetchScopes();
      } catch (err) {
        console.debug(err);
      }

      this.$store.commit('END_LOADING');
      this.loading = false;
    },
    exit() {
      this.logout();
      const url = axios.defaults.baseURL;
      const redirect = `${url.replace('/api', '')}/logout`;
      window.location.href = `${url}/auth/initiatesinglelogout?returnUrl=${redirect}`;
    },
  },
  mounted() {
    this.fetchScopes();
  },
};
</script>
